export const focusError = () => {
  const errorElement = document.querySelectorAll(".Mui-error,.error-anchor")[0];

  if (errorElement)
    errorElement.scrollIntoView({
      behavior: "smooth",
    });
};
